<div class="form-container {{theme}}">
  <form class="form" [formGroup]="formGroup" (ngSubmit)="submit()">
    <ng-content></ng-content>
  </form>
</div>
